module.exports = __webpack_public_path__ + "static/media/arrow_right_red.a4f5ed1f.svg";